export const WHOLE_ORDER = 'wholeOrder';
export const PRICES = 'prices';
export const PRICES_AND_BUMPS = 'pricesAndBumps';
export const TICKETS = 'tickets';
export const TICKETS_AND_ADD_ONS = 'ticketsAndAddOns';

export const isEvent = page => page.type === 'event';

/** The page's three modes: whole, its prices or tickets, and those with its bumps or add-ons. */
export const pageModes = page =>
  isEvent(page)
    ? [WHOLE_ORDER, TICKETS, TICKETS_AND_ADD_ONS]
    : [WHOLE_ORDER, PRICES, PRICES_AND_BUMPS];

export const takesItems = appliesTo => appliesTo !== WHOLE_ORDER;
export const takesBumps = appliesTo =>
  appliesTo === PRICES_AND_BUMPS || appliesTo === TICKETS_AND_ADD_ONS;

/**
 * A rule as the form holds it. `itemIds` are the page's prices (checkout) or tickets (event);
 * `bumpIds` are bump or add-on product ids. An empty list means all of them, including later ones.
 */
export const newRule = (appliesTo = WHOLE_ORDER) => ({ appliesTo, itemIds: [], bumpIds: [] });

export const switchRuleMode = (rule, appliesTo) => ({
  appliesTo,
  itemIds: takesItems(appliesTo) ? rule.itemIds : [],
  bumpIds: takesBumps(appliesTo) ? rule.bumpIds : [],
});

export const ruleFromApi = (rule, page) => ({
  appliesTo: rule.appliesTo ?? WHOLE_ORDER,
  itemIds: ((isEvent(page) ? rule.ticketTypeIds : rule.priceIds) ?? []).map(String),
  bumpIds: (rule.bumpProductIds ?? []).map(String),
});

export const ruleToApi = (rule, page) => {
  const items = takesItems(rule.appliesTo) ? rule.itemIds : [];
  return {
    pageId: page._id,
    appliesTo: rule.appliesTo,
    priceIds: isEvent(page) ? [] : items,
    ticketTypeIds: isEvent(page) ? items : [],
    bumpProductIds: takesBumps(rule.appliesTo) ? rule.bumpIds : [],
  };
};

export const newScopePage = page => ({ ...page, rules: [newRule()] });

/** The coupon's rules grouped by page, in the order the rules name them. */
export const scopePagesFromApi = ({ pages, rules } = {}) => {
  const pageById = new Map((pages ?? []).map(page => [String(page._id), page]));
  const grouped = new Map();
  for (const rule of rules ?? []) {
    const pageId = String(rule.pageId);
    if (!grouped.has(pageId)) grouped.set(pageId, []);
    grouped.get(pageId).push(rule);
  }
  return [...grouped].map(([pageId, pageRules]) => {
    const page = pageById.get(pageId) ?? { _id: pageId };
    return { ...page, rules: pageRules.map(rule => ruleFromApi(rule, page)) };
  });
};
